import React from 'react';
import { Select, Typography } from 'antd';
import { ConfigurationFilter } from '../types';

const { Text } = Typography;
const { Option } = Select;

interface ConfigurationFilterProps {
  value: ConfigurationFilter;
  onChange: (value: ConfigurationFilter) => void;
}

const ConfigurationFilterComponent: React.FC<ConfigurationFilterProps> = ({ value, onChange }) => {
  return (
    <div
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.06)',
        padding: '12px',
        marginBottom: 16,
      }}
    >
      <Text style={{ fontSize: 14, fontWeight: 500, marginRight: 16 }}>Configuration</Text>
      <Select value={value} onChange={onChange} style={{ width: 200 }}>
        <Option value="blocked-collected">Blocked & Collected</Option>
        <Option value="blocked">Blocked</Option>
        <Option value="collected">Collected</Option>
      </Select>
    </div>
  );
};

export default ConfigurationFilterComponent;
